import React from 'react'
import styled from '@emotion/styled'
import Modal from 'components/patterns/Modal'

export const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-footer {
      .ant-btn + .ant-btn {
        margin-left: 0;
      }
    }
  }
`

export const StyledModalContent = styled.div``

export const StyledList = styled.div``

export const StyledOl = styled.ol`
  margin-bottom: 15px;
  padding-left: 17px;
`

export const StyledHeaderContainer = styled.div`
  align-self: stretch;
  margin-bottom: 16px;
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

export const StyledModelHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

// PBI 147363 - Documentation 3: Header title styling per Figma specs
export const HeaderTitle = styled.h3`
  flex: 1 0 0;
  color: rgba(7, 7, 15, 0.87) !important;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`

// PBI 147363 - Documentation 3: Custom warning icon with black exclamation mark
export const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    style={{ marginRight: 10, flexShrink: 0 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7154 14.8189L11.833 1.05409C11.65 0.733897 11.3854 0.467745 11.0661 0.282625C10.7469 0.0975043 10.3843 0 10.0151 0C9.64596 0 9.28337 0.0975043 8.96411 0.282625C8.64486 0.467745 8.38029 0.733897 8.19725 1.05409L0.284762 14.8189C0.100228 15.1379 0.0020951 15.4995 3.31778e-05 15.8679C-0.00202875 16.2363 0.0920503 16.599 0.273001 16.92C0.453952 17.2411 0.715533 17.5095 1.03197 17.6989C1.34841 17.8883 1.70878 17.9921 2.07759 18H17.9026C18.2731 17.9955 18.636 17.8942 18.9552 17.7062C19.2743 17.5182 19.5387 17.2501 19.722 16.9285C19.9053 16.6068 20.0011 16.2429 20 15.8728C19.9988 15.5027 19.9007 15.1394 19.7154 14.8189ZM10.9917 14.4988H8.9885V12.4981H10.9917V14.4988ZM10.9917 9.49703C10.9917 9.76234 10.8861 10.0168 10.6983 10.2044C10.5105 10.392 10.2557 10.4974 9.99009 10.4974C9.72445 10.4974 9.46969 10.392 9.28186 10.2044C9.09402 10.0168 8.9885 9.76234 8.9885 9.49703V7.49634C8.9885 7.23103 9.09402 6.97658 9.28186 6.78898C9.46969 6.60138 9.72445 6.49599 9.99009 6.49599C10.2557 6.49599 10.5105 6.60138 10.6983 6.78898C10.8861 6.97658 10.9917 7.23103 10.9917 7.49634V9.49703Z"
      fill="#EFB115"
    />
    <path d="M10.9917 12.4981H8.9885V14.4988H10.9917V12.4981Z" fill="#07070F" />
    <path
      d="M10.9917 9.49703V7.49634C10.9917 7.23103 10.8861 6.97658 10.6983 6.78898C10.5105 6.60138 10.2557 6.49599 9.99009 6.49599C9.72445 6.49599 9.46969 6.60138 9.28186 6.78898C9.09402 6.97658 8.9885 7.23103 8.9885 7.49634V9.49703C8.9885 9.76234 9.09402 10.0168 9.28186 10.2044C9.46969 10.392 9.72445 10.4974 9.99009 10.4974C10.2557 10.4974 10.5105 10.392 10.6983 10.2044C10.8861 10.0168 10.9917 9.76234 10.9917 9.49703Z"
      fill="#07070F"
    />
  </svg>
)

export const StyledIoSwitchGroup = styled.div`
  margin-bottom: 16px;
`

// PBI 147363 - Documentation 3: Close button styled component (custom X icon)
export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  flex-shrink: 0;

  &:hover {
    opacity: 0.7;
  }
`

// PBI 147363 - Documentation 3: Close icon per Figma specs (14x14)
export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6894 0.321198C13.2753 -0.0929086 12.6064 -0.0929086 12.1923 0.321198L7 5.50284L1.80774 0.31058C1.39363 -0.103527 0.724687 -0.103527 0.31058 0.31058C-0.103527 0.724687 -0.103527 1.39363 0.31058 1.80774L5.50284 7L0.31058 12.1923C-0.103527 12.6064 -0.103527 13.2753 0.31058 13.6894C0.724687 14.1035 1.39363 14.1035 1.80774 13.6894L7 8.49716L12.1923 13.6894C12.6064 14.1035 13.2753 14.1035 13.6894 13.6894C14.1035 13.2753 14.1035 12.6064 13.6894 12.1923L8.49716 7L13.6894 1.80774C14.0929 1.40425 14.0929 0.724687 13.6894 0.321198Z"
      fill="#4F5764"
      fillOpacity="0.87"
    />
  </svg>
)
